module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-view-field",
    style: (_vm.styleParent)
  }, [(_vm.isValid === 1) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [(_vm.viewType !== 'image' && !_vm.isBoolField) ? _c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]) : _vm._e(), _vm._v(" "), (_vm.viewType === 'text') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e()]) : (_vm.viewType === 'list') ? _c('div', {
    staticClass: "w5-view-field-value",
    class: _vm.field === 'data[services]' || _vm.field.indexOf('params[') > -1 ? false : 'w5-status-color-' + _vm.Obj.value
  }, [(_vm.crud === 'ticketrule' && _vm.field === 'rule_set_label') ? [_c('div', {
    staticClass: "w5-list-ticket-label",
    class: 'ticket-label-color-' + (_vm.Obj.value ? String(_vm.Obj.value).toLowerCase() : '')
  })] : [(_vm.Obj.multiselect === true && Array.isArray(_vm.Obj.value) && _vm.Obj.value.length) ? _vm._l((_vm.Obj.value), function(idx, i) {
    return _c('span', {
      key: 'span-' + i
    }, [(i > 0) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("ftc")(_vm.valueFromMultiselect(_vm.Obj.list, idx))))])
  }) : [(_vm.field === 'server_view_type') ? _c('span', {
    class: 'color-type-' + String(_vm.Obj.value),
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.Obj.list[_vm.Obj.value]), (!/_status$/i.test(_vm.field) && !/_register$/i.test(_vm.field) && _vm.field !== 'server_view_type') || (_vm.Obj.value === 'rkn' || _vm.Obj.value === 'infra')))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e(), _vm._v(" "), (/_status$/i.test(_vm.field) && _vm.Obj.text) ? _c('span', [_vm._v("  (" + _vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.Obj.text))) + ")")]) : _vm._e()]]], 2) : (_vm.viewType === 'money') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('Money', {
    attrs: {
      "value": _vm._f("money2")(_vm.Obj.value)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  }), _vm._v(" "), (_vm.Obj.for && _vm.Obj.for !== 'main/ruble') ? _c('span', [_vm._v("/ "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc(_vm.Obj.for))
    }
  })]) : _vm._e()], 1) : (_vm.viewType === 'country') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('span', {
    staticClass: "flag-icon",
    class: 'flag-icon-' + _vm.Obj.value,
    staticStyle: {
      "top": "-1px"
    },
    attrs: {
      "title": _vm.Obj['list'][_vm.Obj.value]
    }
  }), _vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj['list'][_vm.Obj.value])) + "\n\t\t")]) : (_vm.viewType === 'textarea') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [(_vm.Obj.translate === false) ? _c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.linkifyText(_vm.Obj.value)),
      expression: "linkifyText(Obj.value)"
    }],
    staticClass: "w5-view-field-pre"
  }) : _c('pre', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.linkifyText(_vm.Obj.value))),
      expression: "localeFtc(linkifyText(Obj.value))"
    }],
    staticClass: "w5-view-field-pre"
  })]) : (_vm.viewType === 'email') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    staticClass: "linkified",
    attrs: {
      "href": 'mailto:' + _vm.Obj.value
    }
  }, [_vm._v(_vm._s(_vm.Obj.value))])]) : (_vm.viewType === 'skype') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    staticClass: "linkified",
    attrs: {
      "href": 'skype:' + _vm.Obj.value + '?call'
    }
  }, [_vm._v(_vm._s(_vm.Obj.value))])]) : (_vm.viewType === 'datetime') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formater_StrDateFormat(_vm.Obj.value, 'd.m.y H:M:S')) + "\n\t\t")]) : (_vm.viewType === 'date') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.formater_StrDateFormat(_vm.Obj.value, 'd.m.Y')) + "\n\t\t")]) : (_vm.viewType === 'bool') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [(_vm.isBoolField) ? [_c('input', {
    staticClass: "w5-checkbox-field",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "view-field"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))])] : [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.normalizeBooleanValue(_vm.Obj.value) ? 'main/yes' : 'main/no')) + "\n\t\t\t")]], 2) : (_vm.viewType === 'image') ? _c('img', {
    staticClass: "w5-view-field-image",
    class: {
      'real-height': _vm.crud === 'paymentsaved'
    },
    attrs: {
      "src": _vm.srcImage
    }
  }) : (_vm.viewType === 'array') ? _c('div', {
    staticClass: "w5-view-field-value",
    staticStyle: {
      "white-space": "normal"
    }
  }, [_vm._l((_vm.Obj['value']), function(o, idx) {
    return [_c('linkComponent', {
      key: idx,
      attrs: {
        "url": _vm.arrayUrl(idx),
        "text": _vm.arrayText(idx)
      }
    }), (idx < _vm.Obj['value'].length - 1) ? _c('span', {
      key: 'sepor-' + idx
    }, [_vm._v(", ")]) : _vm._e()]
  })], 2) : (_vm.viewType === 'note_file') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('previewImageComponent', {
    attrs: {
      "url": _vm.APIServerUrl + _vm.Obj['value'],
      "title": _vm._f("ftc")(_vm.Obj['title']),
      "text": _vm._f("ftc")(_vm.Obj['text']),
      "size": _vm.Obj['size']
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "w5-view-field-download-link",
    attrs: {
      "href": _vm.APIServerUrl + _vm.Obj['value']
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "file-download"
    }
  })], 1), _vm._v(" "), (_vm.Obj && _vm.Obj['size']) ? _c('span', [_vm._v(_vm._s(_vm.Obj['size']))]) : _vm._e(), _vm._v(" "), (_vm.Obj && _vm.Obj['text']) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj['text'])))]) : _vm._e()], 1) : (_vm.viewType === 'externalUrl') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_c('a', {
    attrs: {
      "href": _vm.makeExternalUrl(_vm.Obj.value),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.value)))])]) : _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value))), (_vm.Obj.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.Obj.for)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isValid === 2) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.Link && _vm.Link.url && String(_vm.Link.url).indexOf('/servergroup/') == 0 ? 'overflow: hidden; text-overflow: ellipsis; white-space: nowrap;' : null)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Link.title)))]), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && _vm.Obj['account_id'] && _vm.Obj['account_name']) ? [(!_vm.Obj['global_filter'] || _vm.Obj['global_filter']['value'] != _vm.Obj['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Obj['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Obj['global_filter'] && _vm.Obj['global_filter']['value'] == _vm.Obj['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.Obj.server_view_type && ('value' in _vm.Obj.server_view_type)) ? _c('span', {
    class: 'color-type-' + String(_vm.Obj.server_view_type.value),
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), (_vm.Link.access) ? _c('linkComponent', {
    staticClass: "w5-view-field-value",
    attrs: {
      "url": _vm.Link.url,
      "text": _vm.Link.text,
      "flagicon": _vm.Link.flag,
      "imageBefore": _vm.Link.image
    }
  }) : _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Link.text)))]), _vm._v(" "), (_vm.Link.online) ? _c('span', {
    staticClass: "online-status-is-on"
  }, [_vm._v(" ●")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isValid === 3) ? _c('div', {
    style: (_vm.styleWrapper)
  }, [(_vm.viewType === 'permissions') ? _c('table', {
    staticClass: "w5-view-field-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/permissions')))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/object')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("ftc")('main/actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.Obj), function(role, key) {
    return _c('tr', {
      key: 'role-' + key
    }, [_c('td', [_vm._v(_vm._s(_vm._f("ftc")(role.name)))]), _vm._v(" "), _c('td', [_vm._l((role.actions), function(R, k, i) {
      return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(R))), (i < Object.keys(role.actions).length - 1) ? _c('span', {
        key: 'sepor-for-' + i
      }, [_vm._v(", ")]) : _vm._e()]
    })], 2)])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === 4 && _vm.viewType === 'serviceData' && _vm.Obj && _vm.Obj.value && typeof _vm.Obj.value === 'object' && Object.keys(_vm.Obj.value).length) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), _vm._l((_vm.Obj.value), function(val, key) {
    return _c('div', {
      key: 'srv-data-' + key,
      staticClass: "w5-view-field-service-data"
    }, [(Array.isArray(val)) ? [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((val), function(arr, idx) {
      return [(idx > 0) ? _c('br', {
        key: 'br-srv-data-' + idx
      }) : _vm._e(), _vm._v(" "), (typeof arr === 'object') ? [_c('span', {
        key: 'val-srv-data-obj-' + idx,
        staticClass: "w5-view-field-value"
      }, [_vm._v("   " + _vm._s(_vm._f("ftc")(idx)))]), _vm._v(" "), _c('br', {
        key: 'br-srv-data-second-' + idx
      }), _vm._v(" "), _vm._l((arr), function(prop, nm, ix) {
        return [_c('span', {
          key: 's1' + idx + '_' + nm
        }, [_vm._v("       " + _vm._s(_vm._f("ftc")(nm)) + ":")]), _vm._v(" "), _c('span', {
          key: 's2' + idx + '_' + nm
        }, [_vm._v(_vm._s(_vm._f("ftc")(prop)))]), (ix < Object.keys(arr).length - 1) ? _c('br', {
          key: 'spbr' + idx + '_' + nm
        }) : _vm._e()]
      })] : [_c('span', {
        key: 'val-srv-data-str-' + idx
      }, [_vm._v("   " + _vm._s(_vm._f("ftc")(idx)) + ": ")]), _vm._v(" "), _c('span', {
        key: 's3' + idx
      }, [_vm._v(_vm._s(arr))])]]
    })] : (typeof val === 'object') ? [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((val), function(prop, nm, idx) {
      return _c('span', {
        key: 'spp1' + nm
      }, [(typeof prop === 'object') ? [_c('span', [_vm._v("   " + _vm._s(_vm._f("ftc")(nm)) + ":"), _c('br')]), _vm._v(" "), _vm._l((prop), function(prop1, nm1, idx1) {
        return _c('span', {
          key: 'sppp1' + nm1
        }, [(typeof prop1 === 'object') ? [_c('span', [_vm._v("       " + _vm._s(_vm._f("ftc")(nm1)) + ":"), _c('br')]), _vm._v(" "), _vm._l((prop1), function(prop2, nm2, idx2) {
          return _c('span', {
            key: 'spppp1' + nm2
          }, [_c('span', [_vm._v("           " + _vm._s(_vm._f("ftc")(nm2)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop2)))]), _vm._v(" "), (idx2 <= Object.keys(prop1).length - 1) ? _c('br') : _vm._e()])
        })] : [_c('span', [_vm._v("       " + _vm._s(_vm._f("ftc")(nm1)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop1)))]), _vm._v(" "), (idx1 <= Object.keys(prop).length - 1) ? _c('br') : _vm._e()]], 2)
      })] : [_c('span', [_vm._v("   " + _vm._s(_vm._f("ftc")(nm)) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(prop)))]), _vm._v(" "), (idx <= Object.keys(val).length - 1) ? _c('br') : _vm._e()]], 2)
    })] : [_c('span', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(key)))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t   " + _vm._s(val) + "\n\t\t\t")]], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isValid === 5 && _vm.Obj && _vm.Obj.value) ? _c('div', {
    staticClass: "w5-view-field-wrapper user-token",
    style: (_vm.styleWrapper)
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('user/token_description')),
      expression: "localeFtc('user/token_description')"
    }],
    staticClass: "note"
  }), _vm._v(" "), (_vm.viewType === 'userToken') ? _c('div', {
    staticClass: "w5-view-field-value"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value)) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    attrs: {
      "disabled": !_vm.isAccess('user/update')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openTokenUpdateModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/edit')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTokenUpdateModal),
      expression: "showTokenUpdateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTokenUpdateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/edit')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTokenUpdateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("ftc")('user/token_update_confirm')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tokenUpdateModalTimer >= 0),
      expression: "tokenUpdateModalTimer >= 0"
    }],
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.tokenUpdateModalTimer && _vm.tokenUpdateModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.tokenUpdateModalCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.tokenUpdateModalButtonTitle)))])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isValid === 6) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Obj.title)))]), _vm._v(" "), (_vm.viewType === 'status') ? _c('div', {
    staticClass: "w5-view-field-value",
    class: _vm.Obj.status_color ? 'w5-status-color-' + String(_vm.Obj.status_color).toLowerCase() : null
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Obj.value)) + "\n\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === 7) ? _c('div', {
    staticClass: "w5-view-field-wrapper",
    style: (_vm.styleWrapper)
  }, [_c('div', {
    staticClass: "w5-view-field-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.arrayViewTitle)))]), _vm._v(" "), (_vm.viewType == 'arrayObjects') ? _vm._l((_vm.Obj), function(element, idx) {
    return _c('div', {
      key: idx
    }, [(element &&
      element['service_id'] && element['service_id']['value'] &&
      element['service_name'] && element['service_name']['value']) ? [(_vm.isAccess('service/view')) ? _c('linkComponent', {
      staticClass: "w5-view-field-value",
      attrs: {
        "url": ("/service/view/" + (element['service_id']['value'])),
        "text": element['service_name']['value']
      }
    }) : _c('div', {
      staticClass: "w5-view-field-value"
    }, [_vm._v(_vm._s(_vm._f("ftc")(element['service_name']['value'])))])] : _vm._e()], 2)
  }) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bdb224"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/view.vue
// module id = 545
// module chunks = 0